import React from "react";
import { FaUserDoctor } from "react-icons/fa6";
import { WiTime9 } from "react-icons/wi";
import { IoCall } from "react-icons/io5";
import allPaths from "../../Config/paths"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Information = (props) => {
    const { selectedLanguage } = props;
    const history = useHistory()
    return (
        <div>
            <div className="fifth-div-information-main">
                <div>
                    <h1>
                        <FaUserDoctor /> {selectedLanguage?.txt_need_a_doctor_for_check_up} ?
                    </h1>
                    <h1 className="just-make-an-appointment">
                        {selectedLanguage?.txt_just_make_an_appointment}
                    </h1>
                    <button onClick={() => history?.push(allPaths?.FIFHTAPPOINTMENT)}>
                        {selectedLanguage?.txt_get_an_appointment}
                    </button>
                </div>
                <div>
                    <h1>
                        <WiTime9 className="fifth-des-info-icon" /> {selectedLanguage?.txt_opening_hours}
                    </h1>
                    <h2>
                        {selectedLanguage?.txt_from_saturday_to_thursday}
                        <br />
                        9:00 AM – 8:00 PM
                    </h2>
                    <h1><IoCall className="fifth-des-info-icon" /> {selectedLanguage?.txt_contact_us_on}:</h1>
                    <h2>
                        01021055271/2
                    </h2>
                </div>
            </div>
            <div className="fifth-des-info-text-and-btn-div">
                <p>
                    {selectedLanguage?.txt_welcome_when_you_arrive}
                </p>
                <button className="fifth-des-more-btn">
                    {selectedLanguage?.txt_more}
                </button>
            </div>
        </div>
    )
}
export default Information